import { render, staticRenderFns } from "./NsTag.vue?vue&type=template&id=33ecefe4&scoped=true&"
import script from "./NsTag.vue?vue&type=script&lang=js&"
export * from "./NsTag.vue?vue&type=script&lang=js&"
import style0 from "./NsTag.vue?vue&type=style&index=0&id=33ecefe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ecefe4",
  null
  
)

export default component.exports